import { useCallback, useRef } from "react";
import { isBefore } from "../../../../date-fns/index.js";
import { useCalendarConfiguration } from "../../context/CalendarRoot.js";
import { parseDate } from "../../context/utils.js";
function getInitialValue(start, end) {
  const res = [];
  if (start) {
    res.push(start);
  }
  if (end) {
    res.push(end);
  }
  if (res.length === 2) {
    return [];
  }
  return res;
}
function useUpdateSelection(onChange, initialStart, initialEnd) {
  const queue = useRef(getInitialValue(initialStart, initialEnd));
  const { dateFnsOptions } = useCalendarConfiguration();
  return useCallback(
    (dateAsString, type = "click") => {
      if (dateAsString) {
        const date = parseDate(dateAsString, dateFnsOptions);
        queue.current.push(date);
        if (queue.current.length === 1) {
          onChange(date, [date], type);
        } else if (queue.current.length === 2) {
          const a = queue.current[0];
          const b = queue.current[1];
          isBefore(a, b) ? onChange(date, [a, b], type) : onChange(date, [b, a], type);
          queue.current = [];
        }
      } else {
        onChange(null, [], type);
        queue.current = [];
      }
    },
    [dateFnsOptions, onChange]
  );
}
export {
  useUpdateSelection
};
//# sourceMappingURL=useUpdateSelection.js.map
